import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { degreeCategories } from '../data/degrees';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const popularPrograms = [{
    name: 'Business',
    path: '/degrees/business'
  }, {
    name: 'Computer Science',
    path: '/degrees/computer-science'
  }, {
    name: 'Nursing',
    path: '/degrees/healthcare'
  }, {
    name: 'Criminal Justice',
    path: '/degrees/criminal-justice'
  }, {
    name: 'Psychology',
    path: '/degrees/psychology'
  }];
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-307" data-mp="36a0dhhc67iv9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308" data-mp="3baod2regt813">
        <div className="flex justify-between items-center h-14 md:h-20" data-id="element-309" data-mp="3b81xc4hf7m7s">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-310" data-mp="3f9nh89sdh0rh">
            <Link to="/" className="flex items-center" data-id="element-311" data-mp="2wlw3bf2mozvx">
              <img src="https://cdn.magicpatterns.com/uploads/hM6pwxGTxH7R3Ug6xJ6sm8/Horizontal_OCG_logo.png" alt="Online College Guide - Your Path Forward" className="h-8 md:h-12 w-auto object-contain" data-id="element-312" data-mp="2rlrijcuotizw" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-313" data-mp="2hpoiccjebufl">
            <div className="relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-314" data-mp="3fa0yvz94tejn">
              

              {/* Dropdown Menu */}
              {isDropdownOpen && <div className="absolute top-full left-0 w-64 bg-white shadow-lg rounded-b-lg border border-gray-100 py-2 z-50" data-id="element-315" data-mp="35k7y7taj2ju6">
                  {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-light hover:text-navy hover:font-medium" onClick={() => setIsDropdownOpen(false)} data-id="element-316" data-mp="1w62t9gl2lvv">
                      {category.name}
                    </Link>)}
                </div>}
            </div>

            <Link to="/get-matched" className="inline-flex items-center bg-crimson hover:bg-crimson-dark text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-crimson" data-id="element-317" data-mp="1wcxrd41rkt35">
              Find My Match
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-318" data-mp="1cooy0qohih22">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center -mr-1 p-1.5 rounded-md text-gray-400 hover:text-navy hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" data-id="element-319" data-mp="1cq8eaha54s3u">
              <span className="sr-only" data-id="element-320" data-mp="2t2ezrqs4st8j">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-321" data-mp="2y1rokh2kcadr" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-322" data-mp="2y1hzqwt9899n" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-200 shadow-inner" data-id="element-323" data-mp="hgmqcubvvyf8">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-324" data-mp="w4ptzx2gey0v">
            <div className="px-3 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-325" data-mp="w6arnvk2ex2y">
              All Degree Categories
            </div>
            {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-navy hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-326" data-mp="1578wgg2bv8ml">
                {category.name}
              </Link>)}

            <div className="pt-3 pb-1 px-3" data-id="element-327" data-mp="1a5k2efpi4yzj">
              <Link to="/get-matched" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center bg-crimson hover:bg-crimson-dark text-white font-semibold text-base px-5 py-3 rounded-md transition-colors duration-200" data-id="element-328" data-mp="3gup0s37rj11w">
                Find My Match
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}